import { environmentService } from '@/utils/services';
import { ToastProgrammatic as Toast, DialogProgrammatic as Dialog } from 'buefy';

const DefaultState = () => {
  return {
    showProgress:false,
    locale: null,
    production: false
  };
},
      state = DefaultState(),
      getters = {
        showProgress: state => state.showProgress,
        locale: state => state.locale,
        production: state => state.production
      },
      mutations = {
        toggleProgressBar(state, payload) {
          state.showProgress = payload;
        },
        updateLocale(state, payload) {
          state.locale = payload
        },
        setProduction(state){
            state.production = environmentService.production;
        }

      },
      actions = {
        toggleProgressBar({commit}, payload) {
          commit('toggleProgressBar', payload)
        },
        setProduction({commit}) {
          commit('setProduction');
        },
        setToastNotification( { commit }, payload) {
          var message = '';
          if (payload.title){
            message = `<h3>${payload.title}</h3> <p>${payload.text}</p>`;
          } else {
            message = payload.text;
          }
          const type = payload.type == 'error' ? 'is-danger' : payload.type == 'success' ? 'is-success' : 'is-warning';
          Toast.open({
            message,
            duration: payload.duration ? payload.duration : 2000,
            position:'is-bottom-right',
            queue:false,
            type
          })
        },
        setDialogNotification({ commit }, payload){
          let content = '';
          var icon = '';
          // if (payload.title) {
          //   content = `<h3>${payload.title}</h3><p>${payload.text}</p>`
          // } else {
          //   content= `<p>${payload.text}</p>`
          // }

          payload.type == 'success' ? icon = 'check-circle-outline' : payload.type == 'danger' ? icon = 'alert-circle-outline' : icon = 'alert-outline';

          return new Promise((resolve, reject) => {
            Dialog.confirm({
              title:payload.title,
              message:payload.text,
              // hasIcon: true,
              confirmText:'Confirm',
              cancelText:'Cancel',
              type:`is-${payload.type}`,
              // icon,
              // iconPack:'mdi',
              // size:'is-medium',
              // animation:'zoom-in',
              // customClass:'notification_alert',
              onConfirm: () => {resolve('Confirmed')},
              onCancel: () => reject('Cancelled')
            });
          })
        },
        setDialogBookingNotification({ commit }, payload){
          var yesButtonText = payload.lang == 'en' ? 'Yes, cancel' : 'Sí, anular';
          var noButtonText = payload.lang == 'en' ? 'No, go back' : 'No, volver';

          return new Promise((resolve, reject) => {
            Dialog.confirm({
              title: payload.title,
              message: payload.text,
              confirmText: yesButtonText,
              cancelText: noButtonText,
              // customClass: 'custom-booking-dialog', // No hace nada en Buefy 0.9.9
              onConfirm: () => { resolve('Confirmed') },
              onCancel: () => reject('Cancelled')
            });
            setTimeout(() => {
              const modals = document.querySelectorAll('.dialog.modal.is-active');
              if (modals.length) {
                modals[modals.length - 1].classList.add('custom-booking-dialog');
              }
            }, 50);
          })
        },
        setDialogAlert({ commit }, payload){
          let content = '';
          var icon = '';
          // if (payload.title) {
          //   content = `<h3>${payload.title}</h3><p>${payload.text}</p>`
          // } else {
          //   content= `<p>${payload.text}</p>`
          // }

          payload.type == 'success' ? icon = 'check-circle-outline' : payload.type == 'danger' ? icon = 'alert-circle-outline' : icon = 'alert-outline';

          Dialog.alert({
            title:payload.title,
            message:payload.text,
            // hasIcon: true,
            confirmText:'OK',
            type:`is-${payload.type}`,
            // customClass:'dialog_alert',
            // icon,
            // size:'is-medium',
            // iconPack:'mdi',
            // animation:'zoom-in',
          })
        },
        updateLocale({ commit }, payload) {
          commit('updateLocale', payload);
        }
      };

export default {
  namespaced:true,
  state,getters,mutations,actions
};



// WEBPACK FOOTER //
// ./src/store/modules/global.js